import React from "react";
import { RentActivityListScreenContainer } from "src/containers";

export const RentActivityListScreen = () => {
  return <RentActivityListScreenContainer />;
};
